<app-oee-modal
    [title]="isClockIn ? 'Clock In' : 'Clock Out'"
    [subtitle]="isClockIn ? 'Start tracking your shift' : 'End your current shift'"
    [icon]="isClockIn ? 'login' : 'logout'"
    [useMaterialIcon]="true"
    [iconColor]="isClockIn ? 'green' : 'red'"
    [tint]="isClockIn ? 'green' : 'red'"
    size="sm"
    (closeClick)="onCancel()">

    <ng-container modal-content>
        @if (isClockIn) {
            <p class="confirm-message">
                You are about to start your shift. Your time will be tracked until you clock out.
            </p>
        } @else {
            <p class="confirm-message">
                You are about to end your shift.
            </p>
            @if (data.elapsed) {
                <div class="elapsed-card">
                    <mat-icon class="elapsed-icon">schedule</mat-icon>
                    <div class="elapsed-info">
                        <span class="elapsed-label">Shift duration</span>
                        <span class="elapsed-value">{{ data.elapsed }}</span>
                    </div>
                </div>
            }
        }
    </ng-container>

    <ng-container modal-actions>
        <button mat-button (click)="onCancel()">Cancel</button>
        @if (isClockIn) {
            <button mat-raised-button color="primary" class="btn-success" (click)="onConfirm()">
                <mat-icon>login</mat-icon>
                Clock In
            </button>
        } @else {
            <button mat-raised-button class="btn-danger" (click)="onConfirm()">
                <mat-icon>logout</mat-icon>
                Clock Out
            </button>
        }
    </ng-container>

</app-oee-modal>
